import React, { useContext, useEffect, useMemo, useState } from "react";
import { Currencies } from "@orbital/games-frontend-library";
import {
  AppContext,
  GameBoardContext,
} from "../../../../context/createContext";
import {
  InputBox,
  InputWrapper,
  Currency,
} from "./autoComponentsStyles/CashOutStyles";
import floorFigure from "../../../configs/floorFigure";

import {
  handleAutoCashOutBlur,
  handleCashoutChange,
} from "../helpers/autoInputCashoutValidation";
import { useTranslation } from "../../../../locale/context";

const CashOut = ({
  autoPilotNumber,
  disabled,
}: {
  autoPilotNumber: string;
  disabled: boolean;
}) => {
  const autoContext = useContext(GameBoardContext);
  const { auth, config, handleNotification } = useContext(AppContext);

  const { t } = useTranslation();
  const languagePack = useMemo(() => {
    return {
      cashoutAt: t("input.cashoutAtLabel"),
    };
  }, [t]);

  const {
    balance: { currency },
  } = auth;
  const { prec, maxbet, minbet } = config;
  const stakeBet = Object.values(autoContext.stakes)[
    autoPilotNumber === "first" ? 0 : 1
  ];
  const funcs = autoContext.funcs;

  const autoPilotInfo = Object.values(autoContext.auto)[
    autoPilotNumber === "first" ? 0 : 1
  ];
  const [autoCashOut, setAutoCashOut] = useState(
    autoPilotNumber === "first"
      ? autoContext.auto.first.cashOut
      : autoContext.auto.second.cashOut
  );
  const [inputsFocus, setInputsFocus] = useState(false);

  useEffect(() => {
    if (+stakeBet < 1 && +autoCashOut < 1.015) {
      return (
        setAutoCashOut("1.01"),
        handleAutoInputs(autoPilotNumber, "cashOut", 1.01)
      );
    }
    if (Number(autoCashOut) <= Number(stakeBet)) {
      setAutoCashOut(floorFigure((+stakeBet * 2).toString(), prec));
      handleAutoInputs(
        autoPilotNumber,
        "cashOut",
        floorFigure((+stakeBet * 2).toString(), prec)
      );
    } else {
      setAutoCashOut(floorFigure(autoPilotInfo.cashOut, prec));
      handleAutoInputs(
        autoPilotNumber,
        "cashOut",
        floorFigure(autoCashOut, prec)
      );
    }
  }, [stakeBet, autoPilotInfo.showAuto]);

  const { handleAutoInputs } = funcs;
  // useEffect(() => {
  //   handleAutoInputs(autoPilotNumber, "cashOut", (+autoCashOut).toFixed(prec))
  // }, [autoCashOut])

  const Focus = (e: any) => {
    e.target.placeholder = "";
    setInputsFocus(true);
    e.currentTarget.select();
  };

  const Blur = (key: string, value: string) => {
    handleAutoCashOutBlur(
      stakeBet,
      prec,
      handleAutoInputs,
      setAutoCashOut,
      autoCashOut,
      key,
      value,
      autoPilotNumber,
      handleNotification,
      minbet,
      maxbet,
      currency
    );
    setInputsFocus(false);
  };

  const onCashoutChange = (e: any) =>
    handleCashoutChange(e, setAutoCashOut, prec);

  return (
    <InputBox focus={inputsFocus}>
      <label>{languagePack.cashoutAt}</label>
      <InputWrapper focus={inputsFocus} disabled={disabled}>
        <Currency>{Currencies[currency]}</Currency>
        <input
          value={autoCashOut}
          onFocus={(e: any) => !disabled && Focus(e)}
          onBlur={() => Blur("cashOut", autoCashOut)}
          onChange={(e) => onCashoutChange(e)}
          inputMode="decimal"
        />
      </InputWrapper>
    </InputBox>
  );
};

export default CashOut;
